import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import TableRegisterCheckIn from "./tableRegisterCheckIn";
import iconPlus from "../../assets/images/booking/plus.svg";
import FormDetail from "./form/detail";
// import { registerCheckInCall } from "../../api/registerCheckIn";
import toast from "react-hot-toast";
import { useRegisterCheckIn } from "../../hooks/useRegisterCheckIn";
import { registerCheckInCall } from "../../api/registerCheckin";
import iconExport from "../../assets/images/product/iconExport.svg";
import { useState } from "react";
import { exportFile } from "../../utils/tools";

export default function RegisterCheckIn() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { refetch, isRefetching, entries, registerCheckInData } =
    useRegisterCheckIn();
  const [paramExport, setParamExport] = useState(null);

  const onSubmitAdd = async (data) => {
    const toastCreate = toast.loading("Đang thêm bản ghi chấm công ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      await registerCheckInCall.create(filteredData);

      await refetch();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleExport = async () => {
    const checkInColumnMapping = {
      status: "Trạng thái",
      employeeCode: "Mã nhân viên",
      employeeFullname: "Tên nhân viên",
      saleBlockName: "Khối",
      saleAreaName: "Vùng",
      branchName: "Chi nhánh",
      checkinPlace: "Địa điểm",
      workingDayRate: "Số công",
      comment: "Lý do",
      checkinTime: "Thời gian tạo bản ghi chấm công",
    };

    if (registerCheckInData?.length) {
      const data = await registerCheckInCall.export(entries, paramExport);
      if (data) {
        exportFile(data, checkInColumnMapping, "bang_quan_ly_dang_ky_cham_cong_ngoai.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý đăng kí chấm công ngoài
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExport} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất exel
            </Text>
          </Button>
          <Button
            // w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            background="var(--linear-gradient-employee)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={onOpen}
          >
            <Image src={iconPlus} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Thêm bản ghi chấm công
            </Text>
          </Button>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableRegisterCheckIn
          isRefetchingWithCreate={isRefetching}
          paramData={setParamExport}
        />
      </Box>
      <FormDetail
        isOpen={isOpen}
        onClose={onClose}
        isEdit={false}
        onSubmit={onSubmitAdd}
      />
    </Box>
  );
}
